import { render, staticRenderFns } from "./LinkBill.vue?vue&type=template&id=4c6997b6&"
import script from "./LinkBill.vue?vue&type=script&lang=js&"
export * from "./LinkBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VCheckbox,VSpacer,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6997b6')) {
      api.createRecord('4c6997b6', component.options)
    } else {
      api.reload('4c6997b6', component.options)
    }
    module.hot.accept("./LinkBill.vue?vue&type=template&id=4c6997b6&", function () {
      api.rerender('4c6997b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LinkBill/LinkBill.vue"
export default component.exports